<template>
<!-- eslint-disable max-len -->
<div
  v-if="starfighter"
  class="narrator-statement-bubble sf"
  :class="{ notails }"
  :style="bubbleStyle"
>
  <slot></slot>
  <nameplate
    :character="speakingCharacter"
    :player="isPlayerSpeaking"
  />
</div>
<sliced-box
  v-else
  class="narrator-statement-bubble native"
>
  <div class="native-content">
    <slot></slot>
  </div>
</sliced-box>
</template>

<script>
import { mapGetters } from 'vuex';

import Nameplate from '../ui/Nameplate';
import SlicedBox from '../ui/SlicedBox';

export default {
  components: {
    Nameplate,
    SlicedBox
  },
  props: {
    narrative: { type: Boolean },
    response: { type: Boolean },
    character: { type: Object },
  },
  computed: {
    ...mapGetters([
      'game',
      'narrativeSpeaker',
      'narrativeResponder',
      'narrativeSpeakerIsPlayer',
      'narrativeResponderIsPlayer',
      'selectedAvatar',
      'starfighter',
      'native'
    ]),
    isPlayerSpeaking() {
      if (this.character) return (this.character === this.selectedAvatar);
      if (this.narrative) {
        if (this.response) {
          return this.narrativeResponderIsPlayer;
        }
        return this.narrativeSpeakerIsPlayer;
      }
      return false;
    },
    speakingCharacter() {
      if (this.character) return this.character;
      if (this.narrative) {
        if (this.response) {
          return this.narrativeResponder;
        }
        return this.narrativeSpeaker;
      }
      return null;
    },
    notails() {
      return !!(this.game.speechBubbleBackgroundColor);
    },
    bubbleStyle() {
      return {
        color:
          this.game.speechBubbleTextColor
            ? this.game.speechBubbleTextColor
            : undefined,
        'background-color':
          this.game.speechBubbleBackgroundColor
            ? this.game.speechBubbleBackgroundColor
            : undefined,
        border:
          this.game.speechBubbleBackgroundColor
            ? 'none'
            : undefined,
      };
    },
  }
};
</script>

<style lang="scss" scoped>
.narrator-statement-bubble {
  position: absolute;
  color: black;
  font-size: 27px;
  // font-weight: bold;
  line-height: 30px;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
}
.narrator-statement-bubble.native {
  height: 240px;
  width: 800px;
  top: 10px;
}
.native-content {
  margin: -70px -60px 0px -60px;
  max-height: 180px;
  overflow-y: auto;
}
.narrator-statement-bubble.sf {
  background-color: white;
  border: 4px solid black;
  border-radius: 35px;
  height: 160px;
  width: 800px;
  margin: 30px 0px;
  padding: 5px 15px 5px 25px;
}
.narrator-statement-bubble.sf::before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 40px 0px 0 40px;
  border-color: black transparent transparent transparent;
  bottom: -41px;
  left: 200px;
}
.narrator-statement-bubble.sf::after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 35px 0px 0 35px;
  border-color: white transparent transparent transparent;
  bottom: -33px;
  left: 201.5px;
}
.narrator-statement-bubble.native::before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 40px 0px 0 40px;
  border-color: rgba(150, 150, 150, 0.35) transparent transparent transparent;
  bottom: -25px;
  left: 240px;
}
.narrator-statement-bubble.native::after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 35px 0px 0 35px;
  border-color: white transparent transparent transparent;
  bottom: -17px;
  left: 241.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/NarratorStatementBubble.vue